/* Erzeugt von D:\bab-arbeit\produktseite\theme_bauen.py aus bab-produkt-aufbau.js und bab-produkt.js. Nicht von Hand ändern. */
var BPD_GT = {"h": [[46, "S", "S", "88–92", "78–82", "92–96"], [48, "M", "S-M", "92–96", "82–86", "96–100"], [50, "M", "M", "96–100", "86–90", "100–104"], [52, "L", "M-L", "100–104", "90–94", "104–108"], [54, "L", "L", "104–108", "94–98", "108–112"], [56, "XL", "XL", "108–112", "98–103", "112–117"], [58, "XL", "XXL", "112–116", "103–108", "117–122"], [60, "XXL", "3XL", "116–120", "108–114", "122–128"], [62, "XXL", "4XL", "120–124", "114–120", "128–134"], [64, "3XL", "5XL", "124–128", "120–126", "134–140"]], "d": [[34, "XS", "XS", "80–84", "62–66", "88–92"], [36, "S", "S", "84–88", "66–70", "92–96"], [38, "S", "S-M", "88–92", "70–74", "96–100"], [40, "M", "M", "92–96", "74–78", "100–104"], [42, "M", "M-L", "96–100", "78–82", "104–108"], [44, "L", "L", "100–104", "82–86", "108–112"], [46, "L", "L-XL", "104–108", "86–90", "112–116"], [48, "XL", "XL", "108–112", "90–95", "116–121"], [50, "XL", "XXL", "112–116", "95–100", "121–126"], [52, "XXL", "3XL", "116–120", "100–105", "126–131"], [54, "XXL", "4XL", "120–124", "105–110", "131–136"], [56, "3XL", "5XL", "124–128", "110–116", "136–142"]], "tables": [["Kasacks Damen", "Kasacks & Kittel Damen", "Für Damenkasacks, Schlupfkasacks und Arztkittel.", ["Größe", "EU", "Brust", "Taille", "Hüfte"], [["XS", 34, "80–84", "62–66", "88–92"], ["S", 36, "84–88", "66–70", "92–96"], ["S-M", 38, "88–92", "70–74", "96–100"], ["M", 40, "92–96", "74–78", "100–104"], ["M-L", 42, "96–100", "78–82", "104–108"], ["L", 44, "100–104", "82–86", "108–112"], ["L-XL", 46, "104–108", "86–90", "112–116"], ["XL", 48, "108–112", "90–95", "116–121"], ["XXL", 50, "112–116", "95–100", "121–126"], ["3XL", 52, "116–120", "100–105", "126–131"], ["4XL", 54, "120–124", "105–110", "131–136"], ["5XL", 56, "124–128", "110–116", "136–142"]]], ["Kasacks Herren", "Kasacks & Kittel Herren", "Für Herrenkasacks, Schlupfkasacks und Laborkittel.", ["Größe", "EU", "Brust", "Taille", "Hüfte"], [["S", 46, "88–92", "78–82", "92–96"], ["S-M", 48, "92–96", "82–86", "96–100"], ["M", 50, "96–100", "86–90", "100–104"], ["M-L", 52, "100–104", "90–94", "104–108"], ["L", 54, "104–108", "94–98", "108–112"], ["XL", 56, "108–112", "98–103", "112–117"], ["XXL", 58, "112–116", "103–108", "117–122"], ["3XL", 60, "116–120", "108–114", "122–128"], ["4XL", 62, "120–124", "114–120", "128–134"], ["5XL", 64, "124–128", "120–126", "134–140"]]], ["Hosen Damen", "Hosen Damen", "Für Schlupfhosen, Berufshosen und Arbeitshosen.", ["Größe", "EU", "Taille", "Hüfte", "Innenbein"], [["XS", 34, "62–66", "88–92", "76–78"], ["S", 36, "66–70", "92–96", "78–80"], ["S-M", 38, "70–74", "96–100", "78–80"], ["M", 40, "74–78", "100–104", "80–82"], ["M-L", 42, "78–82", "104–108", "80–82"], ["L", 44, "82–86", "108–112", "80–82"], ["L-XL", 46, "86–90", "112–116", "80–82"], ["XL", 48, "90–95", "116–121", "80–82"], ["XXL", 50, "95–100", "121–126", "80–82"], ["3XL", 52, "100–106", "126–132", "80–82"]]], ["Hosen Herren", "Hosen Herren", "Für Schlupfhosen, Arzthosen und Arbeitshosen.", ["Größe", "EU", "Taille", "Hüfte", "Innenbein"], [["S", 44, "76–80", "90–94", "80–82"], ["S-M", 46, "80–84", "94–98", "80–82"], ["M", 48, "84–88", "98–102", "82–84"], ["M-L", 50, "88–92", "102–106", "82–84"], ["L", 52, "92–96", "106–110", "82–84"], ["XL", 54, "96–101", "110–115", "82–84"], ["XXL", 56, "101–106", "115–120", "82–84"], ["3XL", 58, "106–112", "120–126", "82–84"], ["4XL", 60, "112–118", "126–132", "82–84"], ["5XL", 62, "118–124", "132–138", "82–84"]]], ["Jacken & Westen", "Jacken & Westen", "Für Arbeitsjacken, Arbeitswesten und Kochjacken. Über Kasack oder Pulli eine Größe größer.", ["Größe", "EU Damen", "EU Herren", "Brust", "Rückenlänge"], [["XS", "34–36", "—", "80–88", "64–66"], ["S", "36–38", "46–48", "84–92", "66–68"], ["M", "40–42", "50–52", "92–100", "68–70"], ["L", "44–46", "54–56", "100–108", "70–72"], ["XL", "48–50", "56–58", "108–116", "72–74"], ["XXL", "50–52", "58–60", "116–124", "74–76"], ["3XL", "54–56", "62–64", "124–132", "76–78"], ["4XL", "58–60", "66–68", "132–140", "78–80"]]], ["Kochbekleidung", "Kochbekleidung", "Für Kochjacken, Kochhosen und Kochkleidung Damen.", ["Größe", "EU Damen", "EU Herren", "Brust", "Taille"], [["XS", "34–36", "—", "80–84", "62–66"], ["S", "36–38", "46–48", "84–92", "66–74"], ["M", "40–42", "50–52", "92–100", "74–82"], ["L", "44–46", "54–56", "100–108", "82–90"], ["XL", "48–50", "56–58", "108–116", "90–98"], ["XXL", "50–52", "58–60", "116–124", "98–106"], ["3XL", "54–56", "62–64", "124–132", "106–114"], ["4XL", "58", "66", "132–140", "114–122"]]], ["Schuhe Damen", "Schuhe Damen", "Für Berufsschuhe, Kochschuhe und Sandalen.", ["EU", "UK", "US", "Fußlänge"], [[35, "2.5", "5", "22,0"], [36, "3.5", "5.5", "22,5"], [37, "4", "6.5", "23,5"], [38, "5", "7", "24,0"], [39, "5.5", "8", "24,5"], [40, "6.5", "8.5", "25,5"], [41, "7", "9.5", "26,0"], [42, "8", "10", "26,5"], [43, "9", "11", "27,5"], [44, "9.5", "11.5", "28,0"]]], ["Schuhe Herren", "Schuhe Herren", "Für Sicherheitsschuhe S1 und S3 sowie ESD-Schuhe.", ["EU", "UK", "US", "Fußlänge"], [[39, "6", "7", "24,5"], [40, "6.5", "7.5", "25,5"], [41, "7.5", "8", "26,0"], [42, "8", "9", "26,5"], [43, "9", "9.5", "27,5"], [44, "9.5", "10.5", "28,0"], [45, "10.5", "11", "28,5"], [46, "11", "12", "29,5"], [47, "12", "12.5", "30,0"], [48, "13", "13.5", "30,5"], [49, "13.5", "14", "31,0"], [50, "14.5", "15", "31,5"]]]]};
var BPD_ICONS = {"check15": "<svg width=\"15\" height=\"15\" viewBox=\"0 0 256 256\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z\"/></svg>", "plus16": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 256 256\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z\"/></svg>", "go": "<svg width=\"18\" height=\"18\" viewBox=\"0 0 256 256\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z\"/></svg>", "shield": "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z\"/></svg>", "drop": "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z\"/></svg>", "ruler": "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"m3 15 12-12 6 6L9 21z\"/><path d=\"m7 11 2 2M10 8l2 2M13 5l2 2\"/></svg>", "pocket": "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 4h14v7a7 7 0 0 1-14 0z\"/><path d=\"M9 8h6\"/></svg>"};
/* Neue Produktseite im Theme: Aufbau im Browser.
   In der lokalen Vorschau erledigt das bauen.py vorab; im Theme gibt es kein Python, deshalb entstehen hier
   aus den Shopify-Daten (product.description, Varianten, Tags) dieselben Teile mit denselben Regeln:
   Größengruppen, Farbpunkte, Fakten, Details-Gruppen, Christins Produktlinks und Tabellen,
   Größentabelle mit Helfer, Ähnliche Modelle. Läuft vor bab-produkt.js (gleiche Datei, davor).
   Ohne JavaScript bleibt die Seite benutzbar: Beschreibung steht als Text da, das Formular kauft normal.
   BPD_GT (Größentabellen) und BPD_ICONS (Symbole) setzt theme_bauen.py beim Zusammenbauen davor. */
(function () { try {
  var root = document.querySelector('.bpd');
  if (!root) return;
  var jsonEl = root.querySelector('[data-bpd-json]');
  var D = JSON.parse(jsonEl.textContent);
  if (!D.theme) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var icon = function (n) { return BPD_ICONS[n] || ''; };
  var euro = function (c) {
    var b = (c / 100).toFixed(2);
    return (D.money || '€{{amount_with_comma_separator}}').replace(/&euro;/g, '€')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, b);
  };
  var tags = (D.tags || []).map(function (t) { return String(t).toLowerCase(); });
  var titel = (D.title + ' ' + (D.type || '')).toLowerCase();
  // Damen/Herren: Tag, sonst Titel oder Adresse (z. B. „…-herrengroe-gr-52-58“)
  var kennung = titel + ' ' + D.handle;
  var damen = tags.indexOf('tg_damen') > -1 || (/damen/.test(kennung) && !/herren/.test(kennung));
  var herren = tags.indexOf('tg_herren') > -1 || (/herren/.test(kennung) && !damen);
  var si = D.sizeIndex, ci = D.colorIndex;

  /* ---------- Beschreibung zerlegen (wie christin(), text_zeilen(), beschreibung() in bauen.py) ---------- */
  var box = document.createElement('div');
  box.innerHTML = D.description || '';
  var text = function (el) { return (el.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').replace(/^[\s;]+|[\s;]+$/g, ''); };

  var tabellen = [];
  $$('table', box).forEach(function (t) {
    var zeilen = $$('tr', t).map(function (tr) { return $$('td,th', tr).map(text); }).filter(function (z) { return z.some(Boolean); });
    if (zeilen.length > 1) tabellen.push(zeilen);
    t.parentNode.removeChild(t);
  });

  var links = [];
  // Nur Links auf BAB-Produkte (relativ oder bab.de), nicht z. B. portwest.com/products/…
  $$('a[href*="/products/"]', box).filter(function (a) {
    var u = a.getAttribute('href') || '';
    return u.charAt(0) === '/' || /^(https?:)?\/\/(www\.)?(bab\.de|bab-berufsbekleidung\.shop|[a-z0-9-]+\.myshopify\.com)\//i.test(u) || u.indexOf(location.host) > -1;
  }).forEach(function (a) {
    var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#\/]/)[0];
    try { h = decodeURIComponent(h); } catch (e) {}
    if (h && h !== D.handle && !links.some(function (l) { return l === h; })) links.push(h);
    // Absatz, der nur aus dem Link besteht, ganz weg; sonst nur den Link
    var p = a.parentNode;
    while (p && p !== box && !/^(P|DIV|H\d|LI)$/.test(p.tagName)) p = p.parentNode;
    if (p && p !== box && text(p) === text(a)) p.parentNode.removeChild(p); else a.parentNode.removeChild(a);
  });

  // Zeilen: Text bis zum nächsten Block, <br> trennt (wie text_zeilen)
  var zeilen = [];
  (function lauf(knoten, art) {
    var puffer = '';
    function raus() {
      puffer.split('\n').forEach(function (z) {
        z = z.replace(/ /g, ' ').replace(/\s+/g, ' ').replace(/^[\s;]+|[\s;]+$/g, '');
        if (z) zeilen.push([art, z]);
      });
      puffer = '';
    }
    [].slice.call(knoten.childNodes).forEach(function (n) {
      if (n.nodeType === 3) { puffer += n.nodeValue; return; }
      if (n.nodeType !== 1) return;
      var tag = n.tagName;
      if (tag === 'BR') { puffer += '\n'; return; }
      if (/^(LI|P|DIV|UL|OL|H\d|SECTION|BLOCKQUOTE)$/.test(tag)) {
        raus();
        // Innerhalb eines Listenpunkts bleibt alles Listenpunkt (aus Herstellerseiten kopiert: <li><h5>…</h5></li>)
        lauf(n, tag === 'LI' || art === 'li' ? 'li' : tag.charAt(0) === 'H' ? 'h' : 'p');
      } else {
        puffer += (function inline(el) {  // <strong>, <span>, <a> …: Text samt <br> als Zeilenumbruch
          var t = '';
          [].slice.call(el.childNodes).forEach(function (m) { t += m.nodeType === 3 ? m.nodeValue : m.nodeType === 1 ? (m.tagName === 'BR' ? '\n' : inline(m)) : ''; });
          return t;
        })(n);
      }
    });
    raus();
  })(box, 'p');

  var specs = [], feats = [], prosa = [];
  zeilen.forEach(function (zz) {
    var art = zz[0], z = zz[1];
    if (art === 'h' && !/:$/.test(z)) { prosa.push('## ' + z); return; }
    var m = z.match(/^([A-Za-zÄÖÜäöüß \/-]{3,32}):\s*(.*)$/);
    if (m && m[2]) {
      var k = m[1].trim(), w = m[2].trim();
      if (/^(farbe|größe|damengröße|herrengröße)/i.test(k)) return;
      if (/modell|material|futter|norm|zertifikat|klasse|rutsch|ausstattung|länge|gewicht|pflege|passform|sohle|kappe/i.test(k)) specs.push([k, w]);
      else feats.push(z);
    } else if (m) {
      return;
    } else if (/^größe /i.test(z) || /^Größen?\s/.test(z)) {
      return;
    } else if (art === 'li' || z.length < 90) {
      feats.push(z);
    } else {
      prosa.push(z);
    }
  });
  feats = feats.filter(function (f) {
    if (/^rückenlänge/i.test(f)) { specs.push(['Rückenlänge', f.split(' ').slice(1).join(' ')]); return false; }
    return true;
  });
  var modell = '';
  specs = specs.filter(function (s) { if (/^modell/i.test(s[0])) { modell = s[1]; return false; } return true; });

  /* ---------- Kopf des Kaufbereichs: Modell, Fakten ---------- */
  if (modell) {
    var mEl = $('[data-bpd-modell]');
    if (mEl) mEl.textContent = ' · Art.-Nr. ' + modell;
    var mMeta = $('[data-bpd-meta-modell]');
    if (mMeta) { $('dd', mMeta).textContent = modell; mMeta.hidden = false; }
  }
  var alles = feats.concat(specs.map(function (s) { return s[1]; })).join(' ').toLowerCase();
  // Wichtigste Ausstattung als Schlagworte oben am Preis (aus Tags, Beschreibung und Größen), höchstens sechs
  var fakten = [];
  var dazu = function (f) { if (fakten.indexOf(f) < 0) fakten.push(f); };
  var klasse = (tags.indexOf('ft_s3') > -1 && 'S3') || ((alles + ' ' + titel).match(/\b(S1P|S1|S2|S3|S4|S5)\b/i) || [])[1];
  if (klasse) dazu('Sicherheitsklasse ' + klasse.toUpperCase());
  if (tags.indexOf('ft_esd') > -1 || /\besd\b/.test(alles + ' ' + titel)) dazu('ESD');
  if (tags.indexOf('ft_haccp') > -1 || /haccp/.test(alles + ' ' + titel)) dazu('HACCP-geeignet');
  var wm = alles.match(/waschbar bis (\d+)/);
  if (wm) dazu('Waschbar bis ' + wm[1] + ' °C');
  if (/autoklav/.test(alles)) dazu('Autoklavierbar');
  if (/industriew/.test(alles)) dazu('Für Industriewäsche');
  if (alles.indexOf('oeko-tex') > -1) dazu('OEKO-TEX Standard 100');
  if (alles.indexOf('elasthan') > -1) dazu('Mit Stretch (Elasthan)');
  if (alles.indexOf('metallfrei') > -1) dazu('Metallfrei');
  var gross = (si > -1 ? D.options[si].values : []).map(function (w) { var m = String(w).match(/^(\d)XL$/i); return m ? +m[1] : 0; });
  var maxXL = Math.max.apply(null, [0].concat(gross));
  if (maxXL >= 3) dazu('Bis Größe ' + maxXL + 'XL');
  var fEl = $('[data-bpd-facts]');
  if (fEl && fakten.length) {
    fEl.innerHTML = fakten.slice(0, 6).map(function (f) { return '<li>' + icon('check15') + esc(f) + '</li>'; }).join('');
    fEl.hidden = false;
  }

  /* ---------- Details-Gruppen (wie details_gruppen) ---------- */
  var GRUPPEN = [
    ['Schutz & Normen', 'shield', /\bS[1-3]\b|S1P|EN ISO|\bESD\b|\bSR[ABC]\b|zehenschutz|kappe|sohle|rutsch|norm|klasse|haccp|metallfrei/i],
    ['Material & Pflege', 'drop', /material|baumwolle|polyester|elasthan|viskose|g\/m|g\/qm|stoff|gewebe|futter|leder|mikrofaser|wasch|°\s*c|bügel|pflege|autoklav|steril|industriew|trockner|kochfest|oeko|öko/i],
    ['Schnitt & Maße', 'ruler', /länge|schnitt|passform|\bfit\b|kragen|ausschnitt|arm\b|ärmel|tailliert|weite|blusenform|form\b/i],
    ['Ausstattung', 'pocket', null]
  ];
  var schoen = function (s) {
    s = s.replace(/\s+/g, ' ').replace(/\b([A-ZÄÖÜ]{8,})\b/g, function (w) { return w.charAt(0) + w.slice(1).toLowerCase(); }).trim();
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  var inhalt = {};
  specs.map(function (s) { return [s[0], s[1]]; }).concat(feats.filter(function (f) { return !/:\s*$/.test(f); }).map(function (f) { return [null, f]; }))
    .forEach(function (kw) {
      var such = (kw[0] || '') + ' ' + kw[1];
      var g = GRUPPEN.filter(function (x) { return !x[2] || x[2].test(such); })[0];
      (inhalt[g[0]] = inhalt[g[0]] || []).push([kw[0], schoen(kw[1])]);
    });
  var grid = $('[data-bpd-dgrid]');
  if (grid) {
    var html = '';
    var normKarte = $('.bpd-dgrp--norm ul', grid);
    GRUPPEN.forEach(function (g) {
      var items = inhalt[g[0]];
      if (!items) return;
      var lis = items.map(function (it) { return '<li>' + (it[0] ? '<span class="bpd-k">' + esc(it[0]) + '</span>' : '') + '<span>' + esc(it[1]) + '</span></li>'; }).join('');
      // Schutz & Normen: bei gepflegtem Normen-Kasten (Metafeld) gehören die Angaben in dieselbe Karte
      if (g[1] === 'shield' && normKarte) { normKarte.insertAdjacentHTML('beforeend', lis); return; }
      html += '<section class="bpd-dgrp"><h3><span class="bpd-dgrp__ic">' + icon(g[1]) + '</span>' + esc(g[0]) + '</h3><ul>' +
        items.map(function (it) { return '<li>' + (it[0] ? '<span class="bpd-k">' + esc(it[0]) + '</span>' : '') + '<span>' + esc(it[1]) + '</span></li>'; }).join('') + '</ul></section>';
    });
    grid.insertAdjacentHTML('beforeend', html);
    var rest = tabellen.filter(function (t) { return !/^gr(ö|oe?)ss?en?|^größe/i.test(t[0][0]); });
    var nachGrid = rest.map(function (t) {
      return '<div class="bpd-table bpd-table--extra" tabindex="0"><table><thead><tr>' + t[0].map(function (k) { return '<th scope="col">' + esc(k) + '</th>'; }).join('') +
        '</tr></thead><tbody>' + t.slice(1).map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>';
    }).join('');
    grid.insertAdjacentHTML('afterend', nachGrid);
    // Die ganze Beschreibung aus Shopify bleibt immer vollständig da (Bilder, Videos, Links, Formatierung),
    // aufklappbar unter den Gruppen. Was im Shop geändert wird, erscheint hier unverändert.
    var roh = $('[data-bpd-desc]');
    if (roh && html) {
      var mehr = document.createElement('details');
      mehr.className = 'bpd-more';
      mehr.innerHTML = '<summary>Ganze Produktbeschreibung ' + icon('plus16') + '</summary>';
      roh.parentNode.insertBefore(mehr, roh);
      mehr.appendChild(roh);
    }
    grid.hidden = !grid.children.length;
  }

  /* ---------- Größen: Normal-, Lang-, Kurzgrößen (wie groessen_gruppen) ---------- */
  var sizeList = si > -1 ? $('[data-bpd-fs="' + si + '"] .bpd-sizes') : null;
  if (sizeList) {
    var werte = D.options[si].values;
    var istZahl = werte.every(function (w) { return /^\d+$/.test(w); });
    var schuh = /schuh|clog|sandale|stiefel/.test(titel);
    if (istZahl && !schuh) {
      var lang = werte.filter(function (w) { return +w >= (damen ? 64 : 90); });
      var kurz = werte.filter(function (w) { return +w <= (damen ? 30 : 31); });
      var normal = werte.filter(function (w) { return lang.indexOf(w) < 0 && kurz.indexOf(w) < 0; });
      var gr = [['normal', 'Normalgrößen', normal], ['lang', 'Langgrößen', lang], ['kurz', 'Kurzgrößen', kurz]].filter(function (g) { return g[2].length; });
      if (gr.length > 1) {
        var seg = '<div class="bpd-seg" role="tablist" aria-label="Größenart">' + gr.map(function (g, n) {
          return '<button type="button" role="tab" data-bpd-seg="' + g[0] + '" aria-selected="' + (n === 0) + '">' + g[1] + '</button>';
        }).join('') + '</div>';
        var listen = gr.map(function (g, n) {
          var ul = document.createElement('ul');
          ul.className = 'bpd-sizes'; ul.setAttribute('data-bpd-group', g[0]); ul.setAttribute('aria-label', g[1]); if (n) ul.hidden = true;
          g[2].forEach(function (w) {
            var b = $('[data-bpd-opt][data-i="' + si + '"][data-v="' + CSS.escape(w) + '"]', sizeList);
            if (b) ul.appendChild(b.parentNode);
          });
          return ul;
        });
        sizeList.insertAdjacentHTML('beforebegin', seg);
        listen.forEach(function (ul) { sizeList.parentNode.insertBefore(ul, sizeList); });
        sizeList.parentNode.removeChild(sizeList);
        if (lang.length) $('[data-bpd-fs="' + si + '"] .bpd-hint-btn').insertAdjacentHTML('beforebegin',
          '<p class="bpd-hint" data-bpd-ghint="lang" hidden>Langgrößen für große Frauen: <b>72</b> entspricht 36, <b>76</b> entspricht 38, <b>80</b> entspricht 40.</p>');
      }
    }
  }

  /* ---------- Farbpunkte ---------- */
  var FARBEN = { schwarz: '#1d1c1c', marine: '#1f2a44', navy: '#1f2a44', anthrazit: '#3b3e43', graphit: '#4a4b50', pink: '#e58fb4', hellblau: '#a9cbe8',
    'light blue': '#a9cbe8', royalblau: '#2f56b0', weiss: '#ffffff', 'weiß': '#ffffff', grau: '#8c8f94', bordeaux: '#6b1f2e', beige: '#d8c6a8',
    brombeer: '#7b2d52', flieder: '#c4a7d8', lila: '#7f4fa3', hellgrau: '#c9cbce' };
  if (ci > -1) $$('[data-bpd-opt][data-i="' + ci + '"]').forEach(function (b) {
    var c = FARBEN[b.getAttribute('data-v').toLowerCase()];
    if (c) b.insertAdjacentHTML('afterbegin', '<span class="bpd-chip__dot" style="--c:' + c + '"></span>');
  });

  /* ---------- Größentabelle + Helfer (wie tabelle()) ---------- */
  var groessen = si > -1 ? D.options[si].values : [];
  var T = function (name) { return BPD_GT.tables.filter(function (t) { return t[0] === name; })[0]; };
  var bis = function (s) { return s.split(/[–-]/); };
  var tab = null; // {titel, quelle, kopf, zeilen[[größe, zellen]], helfer{mass, rows}, tipps}
  var hersteller = tabellen.filter(function (t) { return /^gr(ö|oe?)ss?en?|^größe/i.test(t[0][0]); })[0];
  var tippBrust = 'Brustumfang: waagerecht über die stärkste Stelle der Brust messen, Maßband nicht straff ziehen.';
  var tippKasack = 'Kasacks sitzen locker. Wer ein Shirt darunter trägt oder viel Bewegungsfreiheit möchte, nimmt im Zweifel die größere Größe.';
  // Herstellertabelle aus dem Artikeltext gilt, wenn ihre erste Spalte die Größen des Artikels enthält (z. B. Leiber 00–VIII)
  var passtHersteller = hersteller && groessen.filter(function (g) { return hersteller.some(function (r) { return r[0] === g; }); }).length >= Math.ceil(groessen.length / 2);
  if (passtHersteller) {
    tab = { titel: 'Größen-Umrechnung ' + D.vendor, quelle: 'aus der Artikelbeschreibung',
      kopf: ['Größe'].concat(hersteller[0].slice(1)), zeilen: hersteller.slice(1).map(function (r) { return [r[0], r.slice(1)]; }), helfer: null,
      tipps: ['Die Größe nennt zwei Konfektionsgrößen, z. B. II = Damen 42/44. Liegen Sie dazwischen, nehmen Sie die größere.', tippKasack] };
  } else if (/schuh|clog|sandale|stiefel/.test(titel) && groessen.length) {
    var z = {};
    ['Schuhe Damen', 'Schuhe Herren'].forEach(function (n) { T(n)[4].forEach(function (r) { z[String(r[0])] = [r[1], r[2], r[3]]; }); });
    var zs = groessen.filter(function (g) { return z[g]; }).map(function (g) { return [g, z[g]]; });
    var fehltS = groessen.filter(function (g) { return !z[g]; });
    tab = { titel: 'Schuhgrößen', kopf: ['EU', 'UK', 'US', 'Fußlänge (cm)'], zeilen: zs,
      helfer: { mass: 'Fußlänge', rows: zs.map(function (r) { var l = parseFloat(r[1][2].replace(',', '.')); return { size: r[0], von: l - .5, bis: l - .01 }; }) },
      tipps: ['Fußlänge: abends messen, barfuß auf ein Blatt Papier stellen, Ferse an die Wand, längste Zehe markieren.',
        'Mit dicken Arbeitssocken oder Einlagen eher eine halbe bis ganze Nummer größer wählen.'].concat(fehltS.length ? ['Für Größe ' + fehltS.join(', ') + ' fehlt die Fußlänge in unserer Tabelle. Rufen Sie uns kurz an.'] : []) };
  } else if (groessen.length && groessen.every(function (g) { return /^\d+$/.test(g); }) && damen && /blazer|bluse|kleid|rock|weste|jacke/.test(titel)) {
    var rowsD = BPD_GT.d.filter(function (r) { return groessen.indexOf(String(r[0])) > -1; });
    var hatLang = groessen.some(function (g) { return +g >= 64; });
    tab = { titel: 'Damen-Konfektion (cm)', kopf: ['Größe'].concat(hatLang ? ['Lang'] : [], ['Brust', 'Taille', 'Hüfte']),
      zeilen: rowsD.map(function (r) { var l = String(r[0] * 2); return [String(r[0]), (hatLang ? [groessen.indexOf(l) > -1 ? l : '–'] : []).concat([r[3], r[4], r[5]])]; }),
      helfer: { mass: 'Brustumfang', rows: rowsD.map(function (r) { return { size: String(r[0]), von: +bis(r[3])[0], bis: +bis(r[3])[1] }; }) },
      tipps: [tippBrust, 'Taille: an der schmalsten Stelle messen. Hüfte: an der breitesten Stelle über dem Gesäß.',
        'Liegen Sie zwischen zwei Größen, nehmen Sie die größere.'].concat(hatLang ? ['Langgrößen (72–88) sind für große Frauen: 72 entspricht 36, 76 entspricht 38 und so weiter.'] : []) };
  } else if (groessen.length) {
    var name = /koch|bäcker|küche/.test(titel) ? 'Kochbekleidung'
      : /kasack|kittel/.test(titel) ? (herren ? 'Kasacks Herren' : 'Kasacks Damen')
      : /hose/.test(titel) ? (herren ? 'Hosen Herren' : 'Hosen Damen')
      : /jacke|weste|blouson|parka/.test(titel) ? 'Jacken & Westen' : null;
    var t = name && T(name);
    if (t) {
      // Größe im Shop: Buchstabe (2XL statt XXL) oder Zahl aus der EU-Spalte (Bundhose 52, 56 …)
      var zahlen = groessen.every(function (g) { return /^\d+$/.test(g); });
      var gn = function (r) { return zahlen ? String(r[1]).split(/[–-]/)[0] : r[0] === 'XXL' && groessen.indexOf('2XL') > -1 ? '2XL' : String(r[0]); };
      var b = t[3].indexOf('Brust');
      var gesehen = {};
      var treffer = t[4].filter(function (r) { var g = gn(r); if (groessen.indexOf(g) < 0 || gesehen[g]) return false; gesehen[g] = 1; return true; });
      if (treffer.length) {
        var fehlt = groessen.filter(function (g) { return !treffer.some(function (r) { return gn(r) === g; }); });
        tab = { titel: t[1] + ' (cm)', kopf: ['Größe'].concat(t[3].slice(1).map(function (k) { return k + (/^(Brust|Taille|Hüfte)$/.test(k) ? ' (cm)' : ''); })),
          zeilen: treffer.map(function (r) { return [gn(r), r.slice(1).map(String)]; }),
          helfer: b > -1 ? { mass: 'Brustumfang', rows: treffer.map(function (r) { return { size: gn(r), von: +bis(r[b])[0], bis: +bis(r[b])[1] }; }) } : null,
          tipps: [tippBrust].concat(/^Kasacks/.test(name) ? [tippKasack] : [], fehlt.length ? ['Für ' + fehlt.join(', ') + ' fehlen Maße in unserer Tabelle. Rufen Sie uns kurz an.'] : []) };
      }
    }
  }
  D.helper = { rows: tab && tab.helfer ? tab.helfer.rows : [], zwischen: true };
  jsonEl.textContent = JSON.stringify(D); // bab-produkt.js liest die Daten danach mit Helfer
  if (tab) {
    var fitbox = function (sfx) {
      var tr = tab.zeilen.map(function (r) { return '<tr data-size="' + esc(r[0]) + '"><th scope="row">' + esc(r[0]) + '</th>' + r[1].map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>'; }).join('');
      var h = tab.helfer;
      var eingabe = h && h.rows.length
        ? '<div class="bpd-helper" data-bpd-helper><h3>Größenhelfer</h3><p>' + esc(h.mass) + ' in Zentimetern eingeben, wir zeigen die passende Größe.</p>' +
          '<label for="bpd-cm' + sfx + '">' + esc(h.mass) + ' (cm)</label><div class="bpd-helper__row"><input id="bpd-cm' + sfx + '" inputmode="decimal" autocomplete="off" placeholder="z. B. ' + (Math.floor(h.rows[Math.floor(h.rows.length / 2)].von) + 1) + '"></div><output aria-live="polite"></output>'
        : '<div class="bpd-helper"><h3>So finden Sie Ihre Größe</h3><p>Die Tabelle rechnet die Größe des Herstellers in Ihre gewohnte Konfektionsgröße um.</p>';
      return '<div class="bpd-fit" data-bpd-fitbox><div>' + eingabe + '<ul class="bpd-tips">' + tab.tipps.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' +
        '<p class="bpd-note"><b>Richtwert zur Orientierung.</b> Hersteller schneiden unterschiedlich, im Zweifel beraten wir Sie gern.</p>' +
        (D.phone ? '<p class="bpd-help">Lieber persönlich? <a href="tel:' + esc(D.tel) + '">' + esc(D.phone) + '</a>' + (D.mail ? ' oder <a href="mailto:' + esc(D.mail) + '">' + esc(D.mail) + '</a>' : '') + '</p>' : '') + '</div></div>' +
        '<div class="bpd-table" tabindex="0"><table><caption>' + esc(tab.titel) + ', ' + (tab.quelle ? esc(tab.quelle) : 'Richtwerte aus der <a href="' + esc(D.sizeUrl) + '">BAB-Größentabelle</a>') + '</caption>' +
        '<thead><tr>' + tab.kopf.map(function (k) { return '<th scope="col">' + esc(k) + '</th>'; }).join('') + '</tr></thead><tbody>' + tr + '</tbody></table></div></div>';
    };
    $$('[data-bpd-fitslot]').forEach(function (slot, n) { slot.innerHTML = fitbox(n ? 'b' : 'a'); });
  }

  /* ---------- Christins Produktlinks → „Passend dazu“ ---------- */
  var pair = $('[data-bpd-pair]');
  if (pair && links.length) {
    Promise.all(links.slice(0, 3).map(function (h) {
      return fetch(D.root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(function (q) { return q && q.available !== false; });
      if (!ps.length) return;
      $('ul', pair).innerHTML = ps.map(function (q) {
        var bild = q.featured_image ? q.featured_image + (q.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        return '<li><a class="bpd-pair__item" href="' + esc(q.url || (D.root + 'products/' + q.handle)) + '"><img src="' + esc(bild) + '" alt="" width="64" height="64" loading="lazy">' +
          '<span><b>' + esc(q.title.replace(/\s+/g, ' ')) + '</b><small>' + (q.price_varies ? 'ab ' : '') + euro(q.price_min) + '</small></span>' + icon('go') + '</a></li>';
      }).join('');
      pair.hidden = false;
      D.paare = ps.map(function (q) { return q.handle; });
    });
  }

  /* ---------- Ähnliche Modelle (Shopify-Empfehlungen) ---------- */
  var reco = $('[data-bpd-reco]');
  if (reco) {
    fetch(D.root + 'recommendations/products.json?product_id=' + D.productId + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var ps = (j.products || []).filter(function (q) { return q.handle !== D.handle && !/-sopo-/.test(q.handle) && links.indexOf(q.handle) < 0; }).slice(0, 8);
        if (!ps.length) return;
        $('ul', reco).innerHTML = ps.map(function (q) {
          var bild = q.featured_image ? q.featured_image + (q.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=360' : '';
          var marke = String(q.vendor || '').replace('Exner Fashion GmbH', 'Exner').replace('Hersteller ABEBA', 'ABEBA');
          return '<li><a class="bpd-card" href="' + esc(q.url.split('?')[0]) + '"><img src="' + esc(bild) + '" alt="" width="360" height="360" loading="lazy" decoding="async">' +
            '<span class="bpd-card__txt"><span class="bpd-card__tag">' + esc(marke) + '</span><span class="bpd-card__name">' + esc(q.title.replace(/\s+/g, ' ')) + '</span>' +
            '<span class="bpd-card__price">' + (q.price_max > q.price_min ? 'ab ' : '') + euro(q.price_min) + '</span></span></a></li>';
        }).join('');
        reco.hidden = false;
        var navLink = $('.bpd-jump a[href="#aehnlich"]'); if (navLink) navLink.parentNode.hidden = false;
      }).catch(function () {});
  }
} catch (e) { if (window.console) console.warn('BAB Produktseite: Aufbau übersprungen', e); } })();

(function () {
  var root = document.querySelector('.bpd');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-bpd-json]').textContent);
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  // Im Theme kommt das Preisformat aus Shopify (shop.money_format), in der Vorschau fest
  var euro = function (c) {
    var b = (c / 100).toFixed(2);
    if (!D.money) return '€' + b.replace('.', ',');
    return D.money.replace(/&euro;/g, '€').replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, b);
  };

  // Auswahl: Farbe ist vorbelegt (zeigt das passende Bild), die Größe bewusst nicht,
  // damit niemand aus Versehen die kleinste Größe bestellt
  var sel = D.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
  var ci = D.colorIndex, si = D.sizeIndex;
  if (ci > -1 && !sel[ci]) sel[ci] = D.options[ci].values[0];
  // Kommt der Besuch mit ?variant=… (z. B. aus Google Shopping), gilt genau diese Variante samt Preis
  var vorab = D.selected && D.variants.filter(function (v) { return v.id === D.selected; })[0];
  if (vorab) sel = vorab.o.slice();

  function passend(v, ohne) {
    return sel.every(function (w, i) { return i === ohne || w === null || v.o[i] === w; });
  }
  function variante() {
    if (sel.some(function (w) { return w === null; })) return null;
    return D.variants.filter(function (v) { return passend(v); })[0] || null;
  }

  var priceEl = $('[data-bpd-price]'), fromEl = $('[data-bpd-from]'), statusEl = $('[data-bpd-status]');
  var atcs = $$('[data-bpd-atc]'), barInfo = $('[data-bpd-bar-info]'), barPrice = $('[data-bpd-bar-price]');

  function zeichnen() {
    $$('[data-bpd-opt]').forEach(function (b) {
      var i = +b.getAttribute('data-i'), w = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', sel[i] === w ? 'true' : 'false');
      // Größen, die es in der gewählten Farbe nicht gibt, sichtbar abschwächen (bleiben wählbar)
      var da = D.variants.some(function (v) { return v.o[i] === w && passend(v, i) && v.a; });
      if (da) b.removeAttribute('data-off'); else b.setAttribute('data-off', '');
    });
    $$('[data-bpd-picked]').forEach(function (el) {
      var i = +el.getAttribute('data-i');
      el.textContent = sel[i] ? ': ' + sel[i] : '';
    });
    var v = variante();
    var moegl = D.variants.filter(function (x) { return passend(x); });
    var min = Math.min.apply(null, moegl.map(function (x) { return x.p; }));
    var max = Math.max.apply(null, moegl.map(function (x) { return x.p; }));
    priceEl.textContent = euro(v ? v.p : min);
    fromEl.hidden = !!v || min === max;
    if (barPrice) barPrice.textContent = (v || min === max ? '' : 'ab ') + euro(v ? v.p : min);
    // Streichpreis (Sale) und Nettozeile für Firmenkunden, nur wenn es die Felder gibt
    var cmp = $('[data-bpd-compare]');
    if (cmp) { var was = v && v.c > v.p ? v.c : 0; cmp.hidden = !was; if (was) cmp.textContent = euro(was); }
    var net = $('[data-bpd-net] span');
    if (net) net.textContent = (v || min === max ? '' : 'ab ') + euro(Math.floor((v ? v.p : min) * 100 / 119));
    if (v && D.theme && window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
    }
    var fehlt = D.options.map(function (o, i) { return sel[i] ? null : o.name; }).filter(Boolean);
    atcs.forEach(function (b) {
      var l = $('.bpd-atc__label', b);
      b.disabled = !fehlt.length && !(v && v.a);
      if (fehlt.length) { b.setAttribute('data-need', ''); l.textContent = fehlt[0] + ' wählen'; }
      else { b.removeAttribute('data-need'); l.textContent = v && v.a ? 'In den Warenkorb' : 'Derzeit nicht lieferbar'; }
    });
    if (barInfo) barInfo.textContent = sel.filter(Boolean).join(' · ') || 'Bitte Auswahl treffen';
    if (v) {
      statusEl.toggleAttribute('data-off', !v.a);
      $('span', statusEl).textContent = v.a ? 'Auf Lager, ' + D.lieferzeit : 'Derzeit nicht vorrätig, wir nennen Ihnen gern den Liefertermin';
      $('[data-bpd-id]').value = v.id;
    } else {
      statusEl.removeAttribute('data-off');
      $('span', statusEl).textContent = D.lieferzeit;
    }
  }

  $$('[data-bpd-opt]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = +b.getAttribute('data-i');
      sel[i] = b.getAttribute('data-v');
      if (i === ci) zeigeFarbe();
      zeichnen();
    });
  });

  // Größengruppen (Normal-, Lang-, Kurzgrößen) als Umschalter statt einer langen Reihe
  $$('[data-bpd-seg]').forEach(function (bt) {
    bt.addEventListener('click', function () {
      var g = bt.getAttribute('data-bpd-seg');
      $$('[data-bpd-seg]').forEach(function (x) { x.setAttribute('aria-selected', x === bt ? 'true' : 'false'); });
      $$('[data-bpd-group]').forEach(function (ul) { ul.hidden = ul.getAttribute('data-bpd-group') !== g; });
      $$('[data-bpd-ghint]').forEach(function (p) { p.hidden = p.getAttribute('data-bpd-ghint') !== g; });
    });
  });

  // Menge
  var qty = $('[data-bpd-qty]');
  $$('[data-bpd-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      qty.value = Math.max(1, (+qty.value || 1) + (+b.getAttribute('data-bpd-q')));
    });
  });

  // Warenkorb: Rückmeldung im Knopf (Magic UI "Animated Subscribe Button"). In der Vorschau nur die
  // Rückmeldung, im Theme echt über /cart/add.js; der Kopf des Themes zählt über "cart:updated" mit.
  // Ohne JavaScript schickt das Formular ganz normal an /cart/add.
  var form = $('[data-bpd-form]'), added = $('[data-bpd-added]');
  function fertig() {
    atcs.forEach(function (b) {
      b.setAttribute('data-done', '');
      setTimeout(function () { b.removeAttribute('data-done'); }, 2200);
    });
  }
  function meldung(html, fehler) {
    if (!added) return;
    added.innerHTML = html;
    added.toggleAttribute('data-fehler', !!fehler);
    added.hidden = false;
  }
  function kaufen(ev) {
    ev.preventDefault();
    var fehlt = D.options.findIndex(function (o, i) { return !sel[i]; });
    if (fehlt > -1) {
      var fs = $('[data-bpd-fs="' + fehlt + '"]');
      fs.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
      var erstes = $('button[data-bpd-opt]:not([hidden])', fs);
      if (erstes) erstes.focus({ preventScroll: true });
      return;
    }
    var v = variante();
    if (!v || !v.a) return;
    if (D.vorschau) { fertig(); return; }
    // Niemand darf am Bestellen gehindert werden: Klappt der schnelle Weg nicht (kein fetch, Netz, Serverfehler),
    // geht das Formular ganz normal an Shopify (/cart/add) und landet im Warenkorb. Nur echte Ablehnungen von
    // Shopify (z. B. nur noch 2 Stück da) zeigen wir als Hinweis, mit Shopifys eigenem Text.
    function normal() { form.removeEventListener('submit', kaufen); HTMLFormElement.prototype.submit.call(form); }
    if (!window.fetch || !window.FormData) return normal();
    atcs.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    fetch(D.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        if (r.status === 422) return r.json().then(function (j) { throw { abgelehnt: true, text: j.description || j.message }; });
        if (!r.ok) throw { abgelehnt: false };
        return fetch(D.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); });
      })
      .then(function (cart) {
        // Kopf des BAB-Themes zählt über "cart:updated"; "cart:update" ist das Horizon-Ereignis für Theme-Bausteine
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'bpd', data: { source: 'product-form-component', itemCount: cart.item_count } } }));
        fertig();
        meldung('Im Warenkorb. <a href="' + D.root + 'cart">Zum Warenkorb</a>');
      })
      .catch(function (err) {
        if (err && err.abgelehnt) meldung(err.text || 'Diese Menge ist gerade nicht verfügbar.', true);
        else normal();
      })
      .then(function () { atcs.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  }
  form.addEventListener('submit', kaufen);
  var barBtn = $('.bpd-bar [data-bpd-atc]');
  if (barBtn) barBtn.addEventListener('click', kaufen);

  // Galerie
  var track = $('[data-bpd-track]'), slides = $$('.bpd-gal__slide'), thumbs = $$('[data-bpd-thumb]'), count = $('[data-bpd-count]');
  function gehZu(n, sanft) {
    track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: sanft && !ruhig ? 'smooth' : 'auto' });
  }
  function aktiv(n) {
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === n ? 'true' : 'false'); });
    if (count) count.textContent = (n + 1) + ' / ' + slides.length;
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { gehZu(k, true); aktiv(k); }); });
  var raf;
  track.addEventListener('scroll', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { aktiv(Math.round(track.scrollLeft / track.clientWidth)); });
  }, { passive: true });
  function zeigeFarbe() {
    if (ci < 0) return;
    var v = D.variants.filter(function (x) { return x.o[ci] === sel[ci] && x.img > -1; })[0];
    if (v) { gehZu(v.img, true); aktiv(v.img); }
  }

  // Zoom 1: Lupe beim Überfahren mit der Maus, nur wenn oben rechts eingeschaltet (Schalter merkt sich die Wahl)
  var feinZeiger = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var gal = $('.bpd-gal'), lupe = $('[data-bpd-lupe]');
  function lupeAn(an) {
    gal.toggleAttribute('data-lupe', an);
    if (lupe) lupe.setAttribute('aria-checked', an ? 'true' : 'false');
    if (!an) slides.forEach(function (s) { s.removeAttribute('data-hover'); });
  }
  if (lupe) {
    try { lupeAn(localStorage.getItem('bpd-lupe') === '1'); } catch (e) { lupeAn(false); }
    lupe.addEventListener('click', function () {
      var an = lupe.getAttribute('aria-checked') !== 'true';
      lupeAn(an);
      try { localStorage.setItem('bpd-lupe', an ? '1' : '0'); } catch (e) {}
    });
  }
  slides.forEach(function (s, k) {
    var bild = s.querySelector('img');
    if (feinZeiger) {
      s.addEventListener('pointermove', function (ev) {
        if (ev.pointerType !== 'mouse' || !gal.hasAttribute('data-lupe')) return;
        var r = s.getBoundingClientRect();
        bild.style.transformOrigin = ((ev.clientX - r.left) / r.width * 100) + '% ' + ((ev.clientY - r.top) / r.height * 100) + '%';
        if (!s.hasAttribute('data-hover')) {
          // schärferes Bild erst beim ersten Überfahren nachladen
          if (!bild.dataset.gross) { bild.dataset.gross = '1'; bild.srcset = bild.srcset + ', ' + s.getAttribute('data-bpd-zoom-src') + ' 2000w'; bild.sizes = '1400px'; }
          s.setAttribute('data-hover', '');
        }
      });
      s.addEventListener('pointerleave', function () { s.removeAttribute('data-hover'); });
    }
    s.addEventListener('click', function () { oeffneLb(k); });
  });

  // Zoom 2: Vollbild mit Zoom per Klick/Tipp, Mausrad oder zwei Fingern; gezoomt verschieben, ungezoomt wischen
  var lb = $('[data-bpd-lb]'), stage = $('[data-bpd-lb-stage]'), lbImg = $('img', stage), lbCount = $('[data-bpd-lb-count]');
  var lbN = 0, z = 1, tx = 0, ty = 0, pts = {}, pinch = null, zug = null;
  function setz() {
    lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')';
    lb.toggleAttribute('data-zoomed', z > 1.01);
  }
  function grenzen() {
    var r = stage.getBoundingClientRect(), mx = (z - 1) * r.width / 2, my = (z - 1) * r.height / 2;
    tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
  }
  function zoomBei(nz, cx, cy) {
    nz = Math.max(1, Math.min(4, nz));
    var r = stage.getBoundingClientRect(), px = cx - r.left - r.width / 2, py = cy - r.top - r.height / 2;
    tx = px - (px - tx) * nz / z; ty = py - (py - ty) * nz / z; z = nz;
    if (z <= 1.01) { z = 1; tx = 0; ty = 0; }
    grenzen(); setz();
  }
  function zeigeLb(n) {
    lbN = (n + slides.length) % slides.length;
    z = 1; tx = 0; ty = 0; setz();
    lbImg.src = slides[lbN].getAttribute('data-bpd-zoom-src');
    lbImg.alt = slides[lbN].querySelector('img').alt;
    lbCount.textContent = (lbN + 1) + ' / ' + slides.length;
  }
  function oeffneLb(n) {
    if (!lb.showModal) return;
    zeigeLb(n); lb.showModal();
  }
  var zoomKnopf = $('[data-bpd-zoom]');
  if (zoomKnopf) zoomKnopf.addEventListener('click', function () {
    oeffneLb(Math.round(track.scrollLeft / track.clientWidth));
  });
  $('[data-bpd-lb-close]').addEventListener('click', function () { lb.close(); });
  $$('[data-bpd-lb-step]').forEach(function (b) {
    b.addEventListener('click', function () { zeigeLb(lbN + (+b.getAttribute('data-bpd-lb-step'))); });
  });
  lb.addEventListener('close', function () { gehZu(lbN, false); aktiv(lbN); });
  lb.addEventListener('keydown', function (ev) {
    if (ev.key === 'ArrowRight') zeigeLb(lbN + 1);
    else if (ev.key === 'ArrowLeft') zeigeLb(lbN - 1);
    else if (ev.key === '+' || ev.key === '=') { var r = stage.getBoundingClientRect(); zoomBei(z * 1.5, r.left + r.width / 2, r.top + r.height / 2); }
    else if (ev.key === '-') { var r2 = stage.getBoundingClientRect(); zoomBei(z / 1.5, r2.left + r2.width / 2, r2.top + r2.height / 2); }
  });
  stage.addEventListener('wheel', function (ev) {
    ev.preventDefault();
    zoomBei(z * Math.exp(-ev.deltaY * 0.0025), ev.clientX, ev.clientY);
  }, { passive: false });
  stage.addEventListener('pointerdown', function (ev) {
    stage.setPointerCapture(ev.pointerId);
    pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
    var ids = Object.keys(pts);
    if (ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]];
      pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), z: z }; zug = null;
    } else {
      zug = { x: ev.clientX, y: ev.clientY, tx: tx, ty: ty, weg: false };
    }
    lb.setAttribute('data-dragging', '');
  });
  stage.addEventListener('pointermove', function (ev) {
    if (!pts[ev.pointerId]) return;
    pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
    var ids = Object.keys(pts);
    if (pinch && ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]];
      zoomBei(pinch.z * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, (a.x + b.x) / 2, (a.y + b.y) / 2);
    } else if (zug) {
      var dx = ev.clientX - zug.x, dy = ev.clientY - zug.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) zug.weg = true;
      if (z > 1) { tx = zug.tx + dx; ty = zug.ty + dy; grenzen(); setz(); }
    }
  });
  function los(ev) {
    if (!pts[ev.pointerId]) return;
    delete pts[ev.pointerId];
    if (Object.keys(pts).length) return;
    lb.removeAttribute('data-dragging');
    if (pinch) { pinch = null; return; }
    if (!zug) return;
    var dx = ev.clientX - zug.x;
    if (!zug.weg) { if (z > 1) zoomBei(1, ev.clientX, ev.clientY); else zoomBei(2.5, ev.clientX, ev.clientY); }
    else if (z === 1 && Math.abs(dx) > 60) zeigeLb(lbN + (dx < 0 ? 1 : -1));
    zug = null;
  }
  stage.addEventListener('pointerup', los);
  stage.addEventListener('pointercancel', los);

  // Größentabelle als Dialog (am Handy von unten)
  var dlg = $('[data-bpd-dlg]');
  $$('[data-bpd-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else location.hash = 'groesse'; });
  });
  $$('[data-bpd-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  // Größenhelfer: Maß eingeben, passende Zeile wird markiert und ist mit einem Tipp wählbar
  $$('[data-bpd-helper]').forEach(function (h) {
    var inp = $('input', h), out = $('output', h), tab = h.closest('[data-bpd-fitbox]').querySelector('table');
    inp.addEventListener('input', function () {
      var cm = parseFloat(inp.value.replace(',', '.'));
      $$('tr[data-hit]', tab).forEach(function (r) { r.removeAttribute('data-hit'); });
      if (!cm) { out.textContent = ''; return; }
      var treffer = D.helper.rows.filter(function (r) { return cm >= r.von && cm <= r.bis; })[0];
      if (!treffer) {
        var kl = D.helper.rows[0], gr = D.helper.rows[D.helper.rows.length - 1];
        out.innerHTML = cm < kl.von ? 'Kleiner als unsere Tabelle. Rufen Sie uns kurz an.' : 'Größer als unsere Tabelle. Rufen Sie uns kurz an, wir finden die passende Übergröße.';
        return;
      }
      var tr = tab.querySelector('tr[data-size="' + treffer.size + '"]');
      if (tr) tr.setAttribute('data-hit', '');
      var knopf = $('[data-bpd-opt][data-i="' + si + '"][data-v="' + treffer.size + '"]');
      out.innerHTML = 'Empfehlung: <b>Größe ' + treffer.size + '</b>' + (D.helper.zwischen && cm > treffer.bis - 1 ? ' (liegen Sie zwischen zwei Größen, nehmen Sie die größere)' : '') +
        (knopf ? ' <button type="button" class="bpd-link" data-bpd-take="' + treffer.size + '">übernehmen</button>' : '');
      var take = $('[data-bpd-take]', out);
      if (take) take.addEventListener('click', function () {
        knopf.click();
        if (knopf.closest('[data-bpd-group]')) {
          var g = knopf.closest('[data-bpd-group]').getAttribute('data-bpd-group');
          var s = $('[data-bpd-seg="' + g + '"]'); if (s) s.click();
        }
        if (dlg.open) dlg.close();
        knopf.focus();
      });
    });
  });

  // Handy-Leiste einblenden, sobald der Kaufknopf oben nicht mehr zu sehen ist
  var bar = $('.bpd-bar'), haupt = $('.bpd-buy [data-bpd-atc]');
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var weg = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.toggleAttribute('data-show', weg);
      bar.setAttribute('aria-hidden', weg ? 'false' : 'true');
    }).observe(haupt);
  }

  // Sprungleiste markiert den Abschnitt, in dem man gerade liest
  var links = $$('.bpd-jump a');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false'); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    links.forEach(function (a) { var z = document.getElementById(a.getAttribute('href').slice(1)); if (z) io.observe(z); });
  }

  // Einblenden (Magic UI "Blur Fade") und Spotlight (Magic UI "Magic Card")
  if (!ruhig && 'IntersectionObserver' in window) {
    var fio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); fio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-bpd-fade]').forEach(function (el) { fio.observe(el); });
  } else {
    $$('[data-bpd-fade]').forEach(function (el) { el.classList.add('is-in'); });
  }
  $$('.bpd-card').forEach(function (el) {
    el.addEventListener('pointermove', function (ev) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
      el.style.setProperty('--my', (ev.clientY - r.top) + 'px');
    });
  });

  zeichnen();
  if (vorab) zeigeFarbe(); else aktiv(0);
  // Läuft alles, übernehmen die Knöpfe: verstecktes Feld „id“ an, Ausweich-Auswahlliste aus.
  // Bricht das Skript vorher ab, bleibt die Auswahlliste und das Formular bestellt darüber.
  var idFeld = $('[data-bpd-id]'), ausweich = $('[data-bpd-fallback]');
  if (idFeld) idFeld.disabled = false;
  if (ausweich) { $$('select, input', ausweich).forEach(function (x) { x.disabled = true; }); ausweich.hidden = true; }
  root.setAttribute('data-bpd-bereit', '');
})();

/* bpd-360: Vorder- und Rückansicht zum Drehen (Ziehen, Wischen, Tippen, Pfeiltasten).
   Eigener Baustein, nur aktiv, wenn bauen.py ein Foto-Paar gefunden hat. */
(function () {
  var box = document.querySelector('[data-bpd-360]');
  if (!box) return;
  var root = box.closest('.bpd');
  var D = JSON.parse(root.querySelector('[data-bpd-json]').textContent);
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var auf = root.querySelector('[data-bpd-360-auf]'), zu = box.querySelector('[data-bpd-360-zu]');
  var buehne = box.querySelector('[data-bpd-360-buehne]'), dreh = box.querySelector('[data-bpd-360-dreh]');
  var paare = [].slice.call(box.querySelectorAll('[data-bpd-360-paar]'));
  var ziele = [].slice.call(box.querySelectorAll('[data-bpd-360-ziel]'));
  var tipp = box.querySelector('[data-bpd-360-tipp]');
  if (tipp && window.matchMedia('(pointer: coarse)').matches) tipp.textContent = 'Wischen zum Drehen';
  var winkel = 0;

  function norm(w) { return ((w % 360) + 360) % 360; }
  function hinten(w) { var n = norm(w); return n > 90 && n < 270; }
  function setz(w, ziehen) {
    winkel = w;
    // Bei reduzierter Bewegung kein Drehen, nur Wechsel zwischen den beiden Fotos
    var zeig = ruhig ? (hinten(w) ? 180 : 0) : w;
    if (ziehen) dreh.setAttribute('data-zieht', ''); else dreh.removeAttribute('data-zieht');
    dreh.style.transform = 'rotateY(' + zeig + 'deg)';
    var h = hinten(w);
    buehne.setAttribute('aria-valuenow', Math.round(norm(w)));
    buehne.setAttribute('aria-valuetext', h ? 'Rückansicht' : 'Vorderansicht');
    ziele.forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-bpd-360-ziel') === '180') === h ? 'true' : 'false'); });
  }
  // Auf dem kürzesten Weg zu 0° (vorne) oder 180° (hinten)
  function nach(ziel) { setz(winkel + ((ziel - norm(winkel) + 540) % 360 - 180)); }
  function wenden(richtung) { setz(Math.round(winkel / 180) * 180 + 180 * richtung); }

  var start = null;
  buehne.addEventListener('pointerdown', function (ev) {
    if (ev.button > 0) return;
    start = { x: ev.clientX, w: winkel, id: ev.pointerId, weg: 0 };
    buehne.setPointerCapture(ev.pointerId);
    buehne.setAttribute('data-zieht', '');
  });
  buehne.addEventListener('pointermove', function (ev) {
    if (!start || ev.pointerId !== start.id) return;
    var dx = ev.clientX - start.x;
    start.weg = Math.max(start.weg, Math.abs(dx));
    // Eine Bühnenbreite Ziehen = halbe Drehung
    setz(start.w + dx * 180 / Math.max(240, buehne.clientWidth), true);
  });
  function los() {
    if (!start) return;
    var tippen = start.weg < 6, w0 = start.w;
    start = null;
    buehne.removeAttribute('data-zieht');
    if (tippen) { winkel = w0; wenden(1); } else setz(Math.round(winkel / 180) * 180);
  }
  buehne.addEventListener('pointerup', los);
  buehne.addEventListener('pointercancel', los);
  buehne.addEventListener('keydown', function (ev) {
    var k = ev.key;
    if (k === 'ArrowRight' || k === 'ArrowUp') wenden(1);
    else if (k === 'ArrowLeft' || k === 'ArrowDown') wenden(-1);
    else if (k === 'Home') nach(0);
    else if (k === 'End') nach(180);
    else if (k === 'Enter' || k === ' ') wenden(1);
    else return;
    ev.preventDefault();
  });
  ziele.forEach(function (b) { b.addEventListener('click', function () { nach(+b.getAttribute('data-bpd-360-ziel')); }); });

  function zeigFarbe(f) {
    var p = paare.filter(function (x) { return x.getAttribute('data-bpd-360-paar') === f; })[0];
    if (p) paare.forEach(function (x) { x.hidden = x !== p; });
  }
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-bpd-opt]');
    if (b && +b.getAttribute('data-i') === D.colorIndex) zeigFarbe(b.getAttribute('data-v'));
  });

  function oeffnen(an) {
    box.hidden = !an;
    auf.setAttribute('aria-expanded', an ? 'true' : 'false');
    (an ? buehne : auf).focus({ preventScroll: true });
  }
  auf.addEventListener('click', function () { oeffnen(true); });
  zu.addEventListener('click', function () { oeffnen(false); });
  box.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') { ev.stopPropagation(); oeffnen(false); } });
  setz(0);
})();

/* bpd-360, Teil 3D: KI-Modell erst auf Klick laden (Bibliothek google/model-viewer, Apache-2.0) */
(function () {
  var box = document.querySelector('[data-bpd-360]');
  var ki = box && box.querySelector('[data-bpd-360-ki]');
  if (!ki) return;
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var knopf = box.querySelector('[data-bpd-360-3d]'), buehne = box.querySelector('[data-bpd-360-buehne]');
  var ziele = [].slice.call(box.querySelectorAll('[data-bpd-360-ziel]'));
  var tipp = box.querySelector('.bpd-360__hinweis'), tippAlt = tipp.innerHTML, geladen = false;
  function laden() {
    if (geladen) return;
    geladen = true;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.0.0/dist/model-viewer.min.js';
    document.head.appendChild(s);
    var mv = document.createElement('model-viewer');
    mv.setAttribute('src', ki.getAttribute('data-src'));
    mv.setAttribute('alt', 'KI-generiertes 3D-Modell der Kochjacke in Schwarz, aus Vorder- und Rückfoto errechnet');
    mv.setAttribute('camera-controls', '');
    mv.setAttribute('camera-orbit', '180deg 80deg auto');  // Modell kommt mit dem Rücken zur Kamera
    mv.setAttribute('touch-action', 'pan-y');
    mv.setAttribute('shadow-intensity', '0.6');
    mv.setAttribute('interaction-prompt', 'none');
    if (!ruhig) mv.setAttribute('auto-rotate', '');
    ki.appendChild(mv);
  }
  function zeig(an) {
    if (an) laden();
    ki.hidden = !an;
    buehne.hidden = an;
    knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    if (an) ziele.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    tipp.innerHTML = an ? 'Ziehen dreht · nur in Schwarz' : tippAlt;
  }
  knopf.addEventListener('click', function () { zeig(true); });
  ziele.forEach(function (b) { b.addEventListener('click', function () { if (!ki.hidden) zeig(false); }); });
})();
